module.exports = __webpack_public_path__ + "static/media/sort-circle-up.e492dd64.svg";